import { DictonaryKeys } from '../enums/noTickets';
import { ImagesApp } from './images';

export const genericDictionary: {image: string; title: string[]; subtitle: string[]} = {
  image : ImagesApp.svg.emptyTickets,
  title : ['INFORMATION', 'NO_TICKETS'],
  subtitle : ['INFORMATION', 'MORE_INFORMATION'],
};

export const contentDictonary: Record<DictonaryKeys, { image: string; title: string[]; subtitle: string[] }> = {
  football : {
    ...genericDictionary,
    image : ImagesApp.svg.emptyTicketsFutebol,
    title : ['INFORMATION', 'NO_TICKETS_FUTEBOL'],
    subtitle : ['INFORMATION', 'MORE_INFORMATION_FUTEBOL'],
  },
  eventNotFound : {
    ...genericDictionary,
    title : ['INFORMATION', 'EVENT_NOT_FOUND'],
  },
  ticketListError : {
    ...genericDictionary,
    title : ['INFORMATION', 'ERROR_EMPTY_TICKET_LIST_TITLE'],
    subtitle : ['INFORMATION', 'ERROR_EMPTY_TICKET_LIST_SUBTITLE'],
  },
  soldOut : {
    ...genericDictionary,
    title : ['INFORMATION', 'SALES_IS_NOT_ENABLE'],
    subtitle : ['INFORMATION', 'MORE_INFORMATION_SALES_IS_NOT_ENABLE'],
  },
  salesIsNotEnable : {
    ...genericDictionary,
    title : ['INFORMATION', 'SALES_IS_NOT_ENABLE'],
    subtitle : ['INFORMATION', 'MORE_INFORMATION_SALES_IS_NOT_ENABLE'],
  },
};
